"use strict";

var _regeneratorRuntime = require("/home/azureuser/actions-runner/_work/Admin.WebReact/Admin.WebReact/node_modules/babel-preset-react-app/node_modules/@babel/runtime/regenerator");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _react = _interopRequireDefault(require("react"));

var _reactRouterDom = require("react-router-dom");

var _MenuItem = _interopRequireDefault(require("@material-ui/core/MenuItem"));

var _Divider = _interopRequireDefault(require("@material-ui/core/Divider"));

var _ExternalMenuLink = _interopRequireDefault(require("@sift/skipper/components/appBar/ExternalMenuLink"));

var _classnames = _interopRequireDefault(require("classnames"));

var _withStyles = _interopRequireDefault(require("@material-ui/core/styles/withStyles"));

var _defineStyles = require("@sift/skipper/styles/defineStyles");

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    "default": obj
  };
}

function asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) {
  try {
    var info = gen[key](arg);
    var value = info.value;
  } catch (error) {
    reject(error);
    return;
  }

  if (info.done) {
    resolve(value);
  } else {
    Promise.resolve(value).then(_next, _throw);
  }
}

function _asyncToGenerator(fn) {
  return function () {
    var self = this,
        args = arguments;
    return new Promise(function (resolve, reject) {
      var gen = fn.apply(self, args);

      function _next(value) {
        asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value);
      }

      function _throw(err) {
        asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err);
      }

      _next(undefined);
    });
  };
}

function ownKeys(object, enumerableOnly) {
  var keys = Object.keys(object);

  if (Object.getOwnPropertySymbols) {
    var symbols = Object.getOwnPropertySymbols(object);
    if (enumerableOnly) symbols = symbols.filter(function (sym) {
      return Object.getOwnPropertyDescriptor(object, sym).enumerable;
    });
    keys.push.apply(keys, symbols);
  }

  return keys;
}

function _objectSpread(target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i] != null ? arguments[i] : {};

    if (i % 2) {
      ownKeys(Object(source), true).forEach(function (key) {
        _defineProperty(target, key, source[key]);
      });
    } else if (Object.getOwnPropertyDescriptors) {
      Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
      ownKeys(Object(source)).forEach(function (key) {
        Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
      });
    }
  }

  return target;
}

function _defineProperty(obj, key, value) {
  if (key in obj) {
    Object.defineProperty(obj, key, {
      value: value,
      enumerable: true,
      configurable: true,
      writable: true
    });
  } else {
    obj[key] = value;
  }

  return obj;
}

var styles = (0, _defineStyles.defineStyles)(function (theme) {
  return {
    root: {},
    menuItem: {},
    sectionTitle: _objectSpread(_objectSpread({}, theme.typography.body2), {}, {
      fontWeight: theme.typography.fontWeightBold,
      padding: theme.spacing(1.25, 2, 1, 2),
      textTransform: 'capitalize'
    }),
    menuItemLink: _objectSpread(_objectSpread({}, theme.typography.body1), {}, {
      textDecoration: 'none'
    })
  };
});

function MenuItems(_ref) {
  var className = _ref.className,
      classes = _ref.classes,
      onClose = _ref.onClose,
      adminRoute = _ref.adminRoute,
      navBarRoutes = _ref.navBarRoutes,
      accountRoutes = _ref.accountRoutes,
      additionalRoutes = _ref.additionalRoutes,
      msTeamsRoutes = _ref.msTeamsRoutes,
      onMsTeamsLogout = _ref.onMsTeamsLogout;

  function handleLogout() {
    return _handleLogout.apply(this, arguments);
  }

  function _handleLogout() {
    _handleLogout = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee() {
      return _regeneratorRuntime.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              window.Intercom && window.Intercom('shutdown');

              if (!!onMsTeamsLogout) {
                onMsTeamsLogout();
              } else {
                window.location.assign("".concat(window.location.origin, "/api/auth/logout?redirect=true&setCookies=true"));
              }

            case 2:
            case "end":
              return _context.stop();
          }
        }
      }, _callee);
    }));
    return _handleLogout.apply(this, arguments);
  }

  return /*#__PURE__*/_react["default"].createElement("div", {
    className: (0, _classnames["default"])(classes.root, className)
  }, adminRoute && /*#__PURE__*/_react["default"].createElement(_ExternalMenuLink["default"], {
    href: adminRoute.externalUrl,
    key: adminRoute.key,
    name: adminRoute.name,
    className: classes.menuItemLink,
    onClick: onClose
  }), adminRoute && /*#__PURE__*/_react["default"].createElement(_Divider["default"], null), navBarRoutes && navBarRoutes.map(function (route) {
    if (route.onClick) {
      return /*#__PURE__*/_react["default"].createElement("div", {
        onClick: route.onClick,
        className: classes.menuItemLink,
        key: route.key
      }, /*#__PURE__*/_react["default"].createElement(_MenuItem["default"], {
        onClick: onClose
      }, route.name));
    }

    if (route.url) {
      return /*#__PURE__*/_react["default"].createElement(_reactRouterDom.Link, {
        to: route.url,
        className: classes.menuItemLink,
        key: route.key
      }, /*#__PURE__*/_react["default"].createElement(_MenuItem["default"], {
        onClick: onClose
      }, route.name));
    }

    if (route.externalUrl) {
      return /*#__PURE__*/_react["default"].createElement(_ExternalMenuLink["default"], {
        href: route.externalUrl,
        key: route.key,
        name: route.name,
        className: classes.menuItemLink,
        onClick: onClose
      });
    }

    return null;
  }), navBarRoutes && /*#__PURE__*/_react["default"].createElement(_Divider["default"], null), accountRoutes && accountRoutes.map(function (route) {
    if (route.onClick) {
      return /*#__PURE__*/_react["default"].createElement("div", {
        onClick: route.onClick,
        className: classes.menuItemLink,
        key: route.key
      }, /*#__PURE__*/_react["default"].createElement(_MenuItem["default"], {
        onClick: onClose
      }, route.name));
    }

    if (route.url) {
      return /*#__PURE__*/_react["default"].createElement(_reactRouterDom.Link, {
        to: route.url,
        className: classes.menuItemLink,
        key: route.key
      }, /*#__PURE__*/_react["default"].createElement(_MenuItem["default"], {
        onClick: onClose
      }, route.name));
    }

    return null;
  }), accountRoutes && /*#__PURE__*/_react["default"].createElement(_Divider["default"], null), additionalRoutes && additionalRoutes.map(function (route) {
    return /*#__PURE__*/_react["default"].createElement("a", {
      href: route.externalUrl,
      className: classes.menuItemLink,
      key: route.key,
      target: "_blank",
      rel: "noopener noreferrer"
    }, /*#__PURE__*/_react["default"].createElement(_MenuItem["default"], {
      onClick: onClose
    }, route.name));
  }), additionalRoutes && /*#__PURE__*/_react["default"].createElement(_Divider["default"], null), msTeamsRoutes && msTeamsRoutes.map(function (route) {
    if (route.onClick) {
      return /*#__PURE__*/_react["default"].createElement("div", {
        onClick: route.onClick,
        className: classes.menuItemLink,
        key: route.key
      }, /*#__PURE__*/_react["default"].createElement(_MenuItem["default"], {
        onClick: onClose
      }, route.name));
    }

    if (route.url) {
      return /*#__PURE__*/_react["default"].createElement(_reactRouterDom.Link, {
        to: route.url,
        className: classes.menuItemLink,
        key: route.key
      }, /*#__PURE__*/_react["default"].createElement(_MenuItem["default"], {
        onClick: onClose
      }, route.name));
    }

    if (route.externalUrl) {
      return /*#__PURE__*/_react["default"].createElement(_ExternalMenuLink["default"], {
        href: route.externalUrl,
        key: route.key,
        name: route.name,
        className: classes.menuItemLink,
        onClick: onClose
      });
    }

    return null;
  }), msTeamsRoutes && /*#__PURE__*/_react["default"].createElement(_Divider["default"], null), /*#__PURE__*/_react["default"].createElement(_MenuItem["default"], {
    button: true,
    onClick: handleLogout,
    className: classes.menuItemLink
  }, "Log Out"));
}

var _default = (0, _withStyles["default"])(styles, {
  name: 'SkpAppBarMenuItem'
})(MenuItems);

exports["default"] = _default;